// eslint-disable-next-line no-restricted-imports
import {
  NewOrderSchemaDetailsFragment,
  NewOrderSchemaFragment,
} from 'api/generated/graphql';
import { OrderDetailsSchema, OrderSchema } from 'api/types/data';
import { lodash } from 'helpers';

const parseDetails = (
  details: NewOrderSchemaDetailsFragment
): OrderDetailsSchema => ({
  brokerName: {
    referenceRecordId: details.brokerName.referenceRecordId,
    value: details.brokerName.value,
    directorySchemaName: details.brokerName.reference.directorySchemaName,
    fieldName: details.brokerName.reference.fieldName,
  },
  custodianOrganization: {
    directorySchemaName:
      details.custodianOrganization.reference.directorySchemaName,
    fieldName: details.custodianOrganization.reference.fieldName,

    directoryRecordFieldFilters: details.custodianOrganization.reference
      .directoryRecordFieldFilters
      ? lodash
          .compact(
            details.custodianOrganization.reference.directoryRecordFieldFilters
          )
          .map((filter) => ({
            fieldName: filter.fieldName,
            checked: filter.checked,
          }))
      : undefined,
  },
});

export const parseOrderSchema = (
  orderSchema: NewOrderSchemaFragment
): OrderSchema => ({
  minEndDate: orderSchema.minEndDate,
  financialInstrument: {
    isin: {
      directorySchemaName:
        orderSchema.financialInstrument.isin.reference.directorySchemaName,
      fieldName: orderSchema.financialInstrument.isin.reference.fieldName,
    },
    securityType: {
      directorySchemaName:
        orderSchema.financialInstrument.securityType.reference
          .directorySchemaName,
      fieldName:
        orderSchema.financialInstrument.securityType.reference.fieldName,
    },
    issuer: {
      directorySchemaName:
        orderSchema.financialInstrument.issuer.reference.directorySchemaName,
      fieldName: orderSchema.financialInstrument.issuer.reference.fieldName,
    },
  },
  transactionVolume: {
    nominalQuantity: {
      directorySchemaName:
        orderSchema.transactionVolume.nominalQuantity.reference
          .directorySchemaName,
      fieldName:
        orderSchema.transactionVolume.nominalQuantity.reference.fieldName,
    },
  },
  currency: {
    directorySchemaName: orderSchema.currency.directorySchemaName,
    fieldName: orderSchema.currency.fieldName,
  },

  recipientDetails: parseDetails(orderSchema.recipientDetails),

  senderDetails: parseDetails(orderSchema.senderDetails),
});
